module.exports = __webpack_public_path__ + "static/media/dostawcze_final_v2.e81fb099.jpg";